module.exports = {
  "country": "FR",
  "artist": "Jacqueline Boyer",
  "song": "Tom Pillibi",
  "year": "1960",
  "place": "1",
  "spotify": "3fZIQ0sdsy7u7YDmOpqbxS"
};